import { jsx } from "react/jsx-runtime";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import { validateTidalLicense } from "../../base/index.js";
function SentimentNeutral(props) {
  return /* @__PURE__ */ jsx(
    SentimentNeutralIcon,
    {
      "data-testid": "SentimentNeutral",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "SentimentNeutral",
      "data-tidal-icon-meta": "ratings,sentiments"
    }
  );
}
SentimentNeutral.tidalIconMeta = {
  categories: "ratings,sentiments",
  name: "SentimentNeutral"
};
validateTidalLicense();
export {
  SentimentNeutral
};
//# sourceMappingURL=SentimentNeutral.js.map
